import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import TableHeader from "src/components/TableHeader";
import {
  TOP_SMS_EMAIL_TABLE_TITLE_SORT,
  TOP_SMS_EMAIL_TABLE_TITLE_WIDTHS, TOP_SMS_EMAIL_TABLE_TITLES
} from "src/helpers/Constants";
import { StrategyTableSortType } from "src/helpers/Enums";
import clsx from "clsx";
import WindowLabel from "./WindowLabel";

const TopSMSEmailTable = (props) => {

  const [sortedList, setSortedList] = useState(props.list)

  useEffect(() => {
    setSortedList(props.list)
  }, [props.list])

  const sortList = (index) => {
    const key = StrategyTableSortType[index]
    setSortedList([...sortedList].sort((a, b) => {
      if (typeof a[key] === "string") {
        return a[key].localeCompare(b[key]);
      }
      return a[key] - b[key];
    }))
  }

  function formatRevenue(amount) {
    let formatted = amount?.toFixed(2);
    formatted = formatted?.replace(/\.00$/, '');
    return formatted
  }

  return (
      <div className={ "DashboardTableContainer" }>
        <div className="flex items-center justify-between gap-3">
          <div className={ "DashboardTablesTitle" }>Top { props.title } List</div>
          <WindowLabel label="Last 7 days" />
        </div>
        {sortedList?.length >0 ?
            <div className={ "w-full flex flex-col gap-3" }>
              <TableHeader titles={ TOP_SMS_EMAIL_TABLE_TITLES } widths={ TOP_SMS_EMAIL_TABLE_TITLE_WIDTHS }
                           sort={ TOP_SMS_EMAIL_TABLE_TITLE_SORT } sortList={ sortList }/>
              <div className="TableWrapper">
                <table className="Table w-full h-[60px]" style={{tableLayout: 'fixed'}}>
                  <colgroup>
                    <col style={{height: '60px', width: TOP_SMS_EMAIL_TABLE_TITLE_WIDTHS[0]}} />
                    <col style={{height: '60px', width: TOP_SMS_EMAIL_TABLE_TITLE_WIDTHS[1]}} />
                  </colgroup>
                  <tbody>
                  { sortedList?.map((item, index) => (
                      <tr key={ index } className="border-b h-[60px]">
                        <td className="py-3 px-[10px] border-r text-[12px] leading-[14px] font-semibold align-middle">{ item.name }</td>
                        <td className="border-r align-middle p-0" style={{height: '60px'}}>
                          <div className="h-full py-3 px-[10px] flex justify-between items-center text-[12px] leading-[14px] font-semibold">
                            <div className="flex items-center gap-[2px]">
                              <div className="text-[#15151F] font-[Inter] text-[12px] font-semibold leading-[14px]">${ formatRevenue(item.totalRevenue) }</div>
                              <div className="text-[#15151F] font-[Inter] text-[12px] font-semibold leading-[14px]">/</div>
                              <div className="text-[#8185A8] font-[Inter] text-[12px] font-medium leading-[14px]">${ formatRevenue(item.lastWeekRevenue) }</div>
                            </div>
                            <div className={clsx("whitespace-nowrap text-center font-[Inter] text-[11px] font-semibold leading-[14px]", item?.revenueChangePct > 0 ? "text-[#067647]" : "text-[#B42318]")}>{item?.revenueChangePct > 0 ? "+" + item?.revenueChangePct : item?.revenueChangePct}%</div>
                          </div>
                        </td>
                      </tr>
                  )) }
                  </tbody>
                </table>
              </div>
            </div>
            :
            <div className={"w-full h-full flex items-center justify-center"}>
              <div className={ "flex flex-col items-center justify-center gap-4" }>
                <img alt={ "Logo" } src={ "/media/icons/rowsPurple.svg" } className={ "w-12 h-12" }/>
                <div className={ "flex flex-col gap-1 justify-center items-center" }>
                  <div className={ "EmptyCaseTitle" }>No { props.title } Lists Found</div>
                  <div className={ "EmptyCaseDescription" }>Start building your lists to track their performance here.
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
  );
}

export default injectIntl(TopSMSEmailTable);
